<template>
    <div class="members">
        <List v-if="client_id" :DB="list" :client_id="client_id" @emit="emit"/>
        <div v-if="component" class="fixed-scroller" style="z-index: 200;">
            <component :is="component" @emit="emit"></component>   
        </div>
        <div v-if="offers" style="position: fixed;top:90px;left:100%" :class="['current-offers',{ 'show-open': showCurrentOffers }]" @click="setValue({ showCurrentOffers: !showCurrentOffers })">
            <div style="width: 120px;background-color: rgba(0,255,0,1);height: 40px;border:1px solid black;position: absolute;">
                <div class="hide" style="float: left;background-color: rgba(0,255,0,1);"></div>
                <p style="float: left;line-height: 40px;font-size: 20px;">Offers</p>
            </div>
            <div class="offers-scroller" style="width: 313px;background-color: white;position: absolute;left:120px; ;padding:10px;height:calc(100vh - 90px);overflow-y: scroll;border: 1px solid black">
                <p class="btn" @click="createNewAd">CREATE NEW AD</p>
                <div v-for="page in offers.pages" :key="page.code" style="float: left;width: calc(414px * 0.7 + 22px);height: 370px;">
                    <div style="position: relative;">
                        <div class="grab" @mousedown="downMove($event,offers,page)" @mousemove="moveMove($event,offers,page)" @mouseup="upMove($event,offers,page)" ></div>
                        <Voucher :voucher="page" />
                        <div :style="{ backgroundColor: page.removed ? 'red' : '' }" class="remove-x" @click="removePageFromCampaign($event,offers,page)"></div>
                    </div>
                </div>
            </div>
       </div>
       <div v-if="campaign">
            <div class="campaign-container">
                <div class="campaign-title"><p>Campaign - {{ campaign.title }}</p><div class="x" @click="campaign = false"></div></div>
                <div class="campaign-offers">
                    <div v-for="ad in campaign.pages" :key="ad.code" style="position: relative;width: 320px;margin-top: 10px">
                        <div class="grab" @mousedown="downMove($event,campaign,ad)" @mousemove="moveMove($event,campaign,ad)" @mouseup="upMove($event,campaign,ad)" ></div>
                        <Voucher :voucher="ad" />
                        <div :style="{ backgroundColor: ad.removed ? 'red' : '' }" class="remove-x" @click="removePageFromCampaign($event,campaign,ad)"></div>                        
                    </div>
                </div>
                <div class="btns">
                    <p class="btn del" style="float: left;" @click="deleteCampaign(campaign)">delete</p>
                </div>
            </div>
       </div>
       <div v-if="removePage" class="v-alert" style="height: 538px;">
            <header><p>Remove Ad</p><div class="x" @click="removePage = false"></div></header>
            <Voucher style="position: absolute;z-index: -1;" :voucher="removePage" />
            <div class="label" style="margin-top: 380px;">
                <p style="width: calc(100% - 40px);float: right;margin-top: 5px;">Remove from All Members</p>
                <input type="checkbox" v-model="removeFromCustomers"/>
            </div>
            <div style="position: relative;z-index: 30;">
                <div class="label">
                    <p style="width: calc(100% - 40px);float: right;margin-top: 5px;">Remove from Campaign</p>
                    <input type="checkbox" v-model="removeFromCampaign"/>
                </div>                 
                <div class="btns">
                    <p class="btn red" @click="removeAdFromCampaign(removePage)">remove</p>
                </div> 
            </div>          
        </div>
        <div v-if="editCampaign" class="v-alert edit-campaign">
            <header><p>Edit Campaign</p><div class="x" @click="editCampaign = false"></div></header>
            <div class="label sm">
                <p>Campaign Title</p>
                <input v-model="editCampaign.title" />
            </div>
            <div class="btns">
                <p class="btn" @click="saveCampaign(editCampaign)">save</p>
            </div>
        </div>
        <div v-if='sendingCampaign' class="fixed-scroller">
            <div class="v-alert w-1100 send-campaign" style="margin-top: -90px;">
                <header><p>Send Campaign - <span style="font-weight: bold;">{{ sendingCampaign.title }}</span></p><div class="add-managers"><input type="checkbox" @change="addManagers(sendingCampaign,$event)" /><p>Managers</p></div><div class="x" @click="sendingCampaign = false"></div></header>
                <input placeholder="Search" class="header-search" @keyup="showCustomers(sendingCampaign,$event)" />
                <input placeholder="Search" class="header-search-sending" @keyup="showSendingCustomers(sendingCampaign,$event)" />
                <div class="send-text">
                    <select v-model="sendType"><option v-for="type in sendTypes">{{ type }}</option></select>
                    <div style="display: none;">
                        <input type="checkbox" v-model="sendingCampaign.sendSMS" />
                        <p>Send SMS</p>
                    </div>
                </div>
                <div class="selection-list">
                    <div class="select-from-list">
                        <div v-for="customer in sendingCampaign.customers.filter(c => c.show)" @click="addCustomer(customer)" :key="customer._id" :class="{ selected: customer.selected }">
                            <p class="td-ulb ellip">{{ customer.name }}</p>
                            <p v-if="sendType == 'send SMS'" :class="{ 'no-sms': customer.sendSMS === false }">{{ customer.prettyPhone }}</p>
                            <p v-if="['no Message','send Email'].indexOf(sendType) > -1" :class="['ellip',{ 'no-email': customer.sendEMAIL === false }]">{{ customer.email }}</p>
                        </div>
                    </div>

                    <div class="selected-list">
                        <div v-for="customer in sendingCampaign.customers.filter(c => c.selected && c.showSending).sort((a,b) => a.selected - b.selected )" :key="customer._id">
                            <p class="ellip">{{ customer.name }}</p>
                            <div class="x" @click="addCustomer(customer)"></div>
                        </div>
                    </div>
                </div>
                <div class="btns">
                    <p class="btn b" @click="selectAll(sendingCampaign.customers)">{{ selectedAll ? 'remove all' : 'select all' }}</p>
                    <p class="send-selected">{{ sendingCampaign.customers.filter(c => c.selected).length }} - Selected</p>
                    <p class="btn b" @click="sendSelected(sendingCampaign)">next</p>
                </div>
            </div>
        </div>
        <div v-if="smsCustomers.length > 0" class="fixed-scroller">
            <div class="v-alert w-500 sms-message">
                <header><p>Text Message</p><div class="x" @click="smsCustomers = []"></div></header>
                <div>
                    <p class="sms-message-title">Text Content</p>
                    <textarea v-model="smsMessage"></textarea>
                </div>
                <div class="btns">
                    <p class="btn" @click="smsSend(smsCustomers,smsMessage)">send to {{ smsCustomers.length }}</p>
                </div>
            </div>
        </div>
        <div v-if="emailCustomers.length > 0" class="fixed-scroller email-preview">
            <div class="v-alert w-600" style="margin-left: -505px;">
                <header><p>Email Content</p><div class="x" @click="emailCustomers = []"></div></header>
                <div>
                    <div class="label">
                        <p>Email subject line</p>
                        <input v-model="client.emailSubject" />
                    </div>
                    <div class="label">
                        <p>Banner</p>
                        <img :src="client.emailBanner" @click="uploadClient('emailBanner')" style="width: 220px;padding: 10px;border:1px solid #c0c0c0;" />
                    </div>
                    <div class="label">
                        <p>Heading</p>
                        <input v-model="client.heading" @keyup="updatePreview" />
                    </div>
                    <div class="label">
                        <p>Content</p>
                        <textarea v-model="client.content" @keyup="updatePreview"style="min-height: 250px;"></textarea>
                    </div>
                    <div class="label">
                        <p>Action Button</p>
                        <input v-model="client.action" @keyup="updatePreview" style="width: 235px;"/>
                    </div>
                    <div class="btns">
                        <p class="btn" @click="emailSend(emailCustomers)">send to {{ emailCustomers.length }}</p>
                    </div>
                </div>
            </div>
            <div class="v-alert" style="width:414px;left: calc(50% + 295px);height: 720px;">
                <iframe style="width: 100%;height:100%;border:0px"></iframe>
            </div>
        </div>
        <div v-if="progress" class="fixed-scroller">
            <div class="v-alert w-400">
                <header><p>Sending Messages</p><div class="x" @click="progress = false"></div></header>
                <div class="progress-box">
                    <p>Sent<span>{{ progress.sent }}</span></p>
                    <p>Failed<span>{{ progress.fail }}</span></p>
                </div>
            </div>
        </div>  
    </div> 
   </div>
</template>

<script>

import { mapMutations, mapActions } from 'vuex'
import List from '../components/List.vue'
import { format } from 'date-fns';
import prettyPhone from '../utils/prettyPhone.js'
import WebSoc from '../utils/WebSoc.js';
import Voucher from '../components/Voucher.vue';
import distanceDate from '@/utils/distanceDate.js'
import Alert from '@/utils/Alert.js'
import getCampaignPageCode from '@/utils/getCampaignPageCode.js';
import UploadFile from '@/utils/UploadFile.js';
import postMinify from  '@/utils/postMinify.js';
import EditImage from '@/utils/EditImage.js';
import createAd from '@/components/createAd.vue';

export default {
    name: 'campaigns',
    components: {
        List,
        Voucher,
        createAd
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        //offers () { return this.$store.state.currentOffers },
        showCurrentOffers () { return this.$store.state.showCurrentOffers }
    },
    created () {
        this.list.filter.client_id = this.client_id;      
        this.list.db = this.client_id+'-customers'; 
    },
    mounted () {
        this.getCurrentOffers( this.client_id );
    },
    data () {
        return {
            sendTypes: ['no Message','send SMS','send Email'],
            sendType: 'no Message',
            emaiBanner: '',
            component: '',
            item: false,
            offers: false,
            campaign: false,
            inCampaign: false,
            showCurrent: false,
            editCampaign: false,
            moving: false,
            removePage: false,
            sendingCampaign: false,
            selectedAll: false,
            smsCustomers: [],
            emailCustomers: [],
            smsMessage: '',
            progress: false,
            list: { 
                t: 'survey-list',
                DB: 'surveys',
                dbClient_id: '',
                storeDB: true,
                title: 'Campaigns',
                db: '',
                fields: [
                    { title: 'Title', class: 'td-ulb', field: 'title', width: 270 },
                    { title: 'Created', field: 'created', class: 'ta-r', width: 140, map: item => format(item.created,'dd/MM/yy') },
                    { title: 'Updated', field: 'update', class: 'ta-r', width: 170, map: item => distanceDate(item.update,'dd/MM/yy') },
                    { title: 'Sent', field: 'qtySent', class: 'ta-r', type: 'num', width: 90 },
                    { title: 'Opens', field: 'opens', class: 'ta-r', type: 'num', width: 90 },
                    { title: 'Unique', field: 'uniqueOpens', class: 'ta-r', width: 90, map: item => Object.keys(item.uniqueOpens || {}).length },
                    { title: 'Ads', field: 'pages', class: 'ta-r', width: 90, map: item => item.pages.length },
                    { title: 'Send', field: 'send', class: 's-btn', width: 120, map: () => 'send' }
                ],
                filter: { client_id: 1, live: true, currentOffers: { $ne: true }, loyalty: true },
                project: {},
            } 
        }
    },
    methods: {
        createNewAd () {
            this.component = 'createAd';
        },
        uploadClient ( type ) {
            var typeLU = {
                emailBanner: { width: 828, height: 300, ratio: NaN },
                headerPlain: { width: 828, height: 153 },
                headerBack: { width: 828, height: 153 },
                loyalPlain: { width: 232, height: 251 },
                loyalStamp: { width: 232, height: 251 },
                dashBanner: { width: 400, height: 190 },
                favicon: { width: 48, height: 48 },
                appleFav: { width: 180, height: 180 },
                joinPage: { width: 818, height: 1100, crop: false },
                twoele: { width: 687, height: 844, crop: false },
                loyal1: { width: 818, height: 200, crop: false },
                loyal2: { width: 818, height: 200, crop: false },
                welcome: { width: 818, height: 300, crop: false },
                catWords: { width: 818, height: 200, crop: false },
                contactUs: { width: 818, height: 300, crop: false },
                referWords: { width: 818, height: 300, crop: false },
                man: { width: 40, height: 40, crop: false },
                plain: { width: 232, height: 251 },
                stamp: { width: 232, height: 251 }
            }
            var LU  = typeLU[type] || typeLU[type.split('.')[1]]

            if ( !LU ) return console.log('!LU',type); 
            
            if ( type.indexOf('.') > - 1 ) {
                var Type = type.split('.');
                var LU = typeLU[Type[1]];
            } else {
                var LU  = typeLU[type];
            }

            UploadFile(result => {
                
                if ( LU.crop === false ) {
                    this.client[type] = '';
                    return postMinify(result.result,resp => {
                        if ( Type ) {
                            if ( !this.client[Type[0]] ) { this.$set(this.client,Type[0],{}) }
                            this.$set(this.client[Type[0]],Type[1],resp.url)
                        } else {
                            this.client[type] = resp.url
                        }
                        this.updatePreview();
                        this.$forceUpdate()
                    })
                }
                EditImage({
                    src: result.result,
                    width: LU.width,
                    height: LU.height,
                    ratio: isNaN(LU.ratio) ? NaN : ( LU.width / LU.height )
                },result => {
                    this.client[type] = '';
                    this.setValue({ showSpinner: true });
                    postMinify(result.result,resp => {
                        this.setValue({ showSpinner: false });
                        if ( Type ) {
                            if ( !this.client[Type[0]] ) { this.$set(this.client,Type[0],{}) }
                            this.$set(this.client[Type[0]],Type[1],resp.url)
                        } else {
                            this.client[type] = resp.url
                        }

                        this.updatePreview();
                        this.$forceUpdate();

                    });
                })
            })
        },
        deleteCampaign ( campaign ) {
            if ( campaign.pages.length > 0 ) return Alert.message('Cannot delete campaign with Ads');
            Alert.yesno('Delete '+campaign.title+'?',yes => {
                if ( !yes ) return;
                this.editCampaign = false;
                WebSoc.SEND('delete',{ DB: 'surveys', _id: campaign._id },() => {
                    console.log('deleted');
                })
            })
        },
        addCampaign () {
            this.editCampaign = {
                id: '',
                iss: 0,
                title: '',
                client: '',
                client_id: this.client_id,
                client: false,
                about: '',
                created: Date.now(),
                backgroundColor: '#ffffff',
                buttonColor: '#ffffff',
                buttonFontColor: '#ffffff',
                fontColor: '#ffffff',
                styleSurvey: false,
                staffSurvey: false,
                parent_id: false,
                child_ids: [],
                fontStyle: '',
                fontLink: '',
                fontName: '',
                pageLogo: '',
                clicks: 0,
                qtySent: 0,
                unique: {},
                user: '',
                pages: [],
                ham: [],
                issues: [],
                quill: false
            }
        },
        saveCampaign ( campaign ) {
            
            this.editCampaign = false;

            if ( !campaign._id ) {
                return this.updateCampaign({
                    saveCampaign: campaign
                });
            }

            
            var fields = ['title'];
            
            var udpate = field.reduce((p,f) => {
                p[f] = campaign[f];
            },{});
            

        },
        showCampaign ( campaign_id ) {
            WebSoc.SEND('get',{ DB: 'surveys', _id: campaign_id },campaign => {
                campaign.pages.forEach(page => {   
                    page.removed = page.removed || false;
                    page.campaign_id = campaign._id;
                });
                this.campaign = campaign;
            })
        },
        sendCampaign ( campaign ) {
            console.log('sendCampaign campaign.title',campaign.title);
            WebSoc.SEND('search',{ DB: this.client_id+'-customers', find: { $or: [ { closed: false }, { closed: { $exists: false } } ] }, project: { sendSMS: 1, sendEMAIL: 1, msisdn: 1, name: 1, manager: 1, email: 1 } },customers => {
                customers.forEach(c => { 
                    c.prettyPhone = prettyPhone(c.msisdn);
                    c.selected = false;
                    c.show = true; 
                    c.showSending = true;
                });
                campaign.customers = customers;
                campaign.sendSMS = true;
                this.selectedAll = false;
                this.sendingCampaign = campaign;
            });
        },
        addManagers ( campaign, e ) {
            var checked = e.target.checked ? Date.now() : false;
            campaign.customers.filter(c => c.manager).forEach((c,i) => c.selected = checked ? checked + i : checked);
            this.$forceUpdate();
        },
        selectAll ( customers ) {
            if ( this.selectedAll ) {
                customers.forEach(c => c.selected = false);
                this.selectedAll = false;
                return this.$forceUpdate();
            }
            var now = Date.now();
            customers.forEach((c,i) => {
                c.selected = now + i;
            });
            this.selectedAll = true;
            this.$forceUpdate();
        },
        addCustomer ( customer ) {
            if ( customer.selected ) {
                customer.selected = false
                customer.showSending = false;
            } else {
                customer.selected = Date.now();
                customer.showSending = true;
            }
            this.$forceUpdate();
        },
        showCustomers ( campaign, e ) {
            var text = new RegExp(e.target.value.split('').join(' *'),'i');
            campaign.customers.forEach(c => {
                c.show = text.test(c.name+c.prettyPhone);
                //c.showSending = c.show;
            });
            this.$forceUpdate();
        },
        showSendingCustomers ( campaign, e ) {
            var text = new RegExp(e.target.value.split('').join(' *'),'i');
            campaign.customers.forEach(c => {
                c.showSending = text.test(c.name+c.prettyPhone);
            })
        },
        sendSelected ( campaign ) {
            var selected = campaign.customers.filter(c => c.selected).map(c => { return { _id: c._id } })
            if ( selected.length == 0 ) selected = campaign.customers.map(c => { return { _id: c._id  }})
            switch ( this.sendType ) {
                case 'send SMS':
                    this.emailCustomers = [];
                    return this.smsCustomers = selected;

                case 'send Email':
                    this.smsCustomers = [];
                    return WebSoc.SEND('get',{ DB: 'clients', _id: this.client_id, project: { siteURL: 1, action: 1, emailSubject: 1, title: 1, emailHtml_id: 1, backgroundColor: 1, fontColor: 1, btnColor: 1, btnFontColor: 1, emailBanner: 1, headerPlain: 1 } },client => {

                        client.heading = client.heading || 'Email Heading';
                        client.content = client.content || 'Message Content';
                        client.action  = client.action  || 'FIND OUT MORE';
                        client.emailSubject = client.emailSubject || 'A Message from '+client.title;

                        this.client = client;

                        WebSoc.SEND('get',{ DB: 'quill', _id: client.emailHtml_id },quill => {
                            this.quill = quill;
                            this.emailCustomers = selected; 
                            this.$nextTick(() => {
                                this.showEmailPreview(); 
                            });
                        })
                    })
                    return       
            }
            
            console.log('SEND WITHOUT MESSAGE')

            return; 

            Alert.yesno('Send to '+selected.length+' Member'+(selected.length > 1 ? 's' : '')+'?',yes => {
                if ( !yes ) return;
                WebSoc.SEND('sendCampaign',{ campaign_id: campaign._id, client_id: this.client_id, customers, message, sendText: false,   },resp => {
                resp.sent && ( this.progress.sent += resp.sent )
                resp.fail && ( this.progress.fail += resp.fail )
            })
            })
            
        },
        updatePreview () {
            clearTimeout(this._updatePreview);
            this._updatePreview = setTimeout(() => {
                this.showEmailPreview();
            },400);
        },
        showEmailPreview () {
            var campaign = this.sendingCampaign;
            var client = this.client;
            var html = this.quill.html;
            var iframe = this.$el.querySelector('.email-preview iframe');
            var content = iframe.contentWindow.document;
                html =  html.replace('$banner$',client.emailBanner)
                            .replace('$heading$',client.heading)
                            .replace('$content$',client.content)
                            .replace('$action$',client.action)
                            .replace(/\$backgroundColor\$/g,client.backgroundColor)
                            .replace(/\$btnColor\$/g,client.btnColor)
                            .replace(/\$btnFontColor\$/g,client.btnFontColor) 
                            .replace(/\$fontColor\$/g,client.fontColor)
                            .replace(/\$headerPlain\$/g,client.headerPlain);

                if ( !campaign._id ) {
                    html = html.replace('$hide$','display:none')
                }            

                content.open();
                content.write(html);
                content.close();

        },
        smsSend ( customers, message ) {
            var sendText = this.sendingCampaign.sendSMS;
            
            if ( !sendText ) return Alert.message('Send SMS Must be check to Send a Text Message Campaign');
            
            Alert.yesno('Send SMS to '+customers.length+' ?',yes => {
                if ( !yes ) return;

                this.progress = {
                    sent: 0,
                    fail: 0
                }
                this.smsCustomers = [];
                WebSoc.SEND('sendCampaign',{ _id: this.sendingCampaign._id, client_id: this.client_id, customers, message, sendText },resp => {
                    resp.sent && ( this.progress.sent = resp.sent )
                    resp.fail && ( this.progress.fail = resp.fail )
                })
            })

        },
        emailSend () {
            var client = this.client;
            
            var customers = this.emailCustomers.map(e => { return { _id: e._id } });
            
            var { emailSubject, emailBanner, heading, content, action, backgroundColor, btnColor, btnFontColor, fontColor, headerPlain } = client;

            var updateClient = { emailSubject, emailBanner, heading, content, action }
            
            var emailHtml = this.quill.html.replace('$banner$',client.emailBanner)
                                            .replace('$heading$',client.heading)
                                            .replace('$content$',client.content)
                                            .replace('$action$',client.action)
                                            .replace('$unsub$','https://'+client.siteURL)
                                            .replace(/\$backgroundColor\$/g,client.backgroundColor)
                                            .replace(/\$btnColor\$/g,client.btnColor)
                                            .replace(/\$btnFontColor\$/g,client.btnFontColor) 
                                            .replace(/\$fontColor\$/g,client.fontColor)
                                            .replace(/\$headerPlain\$/g,client.headerPlain);


            Alert.yesno('Send Email to '+customers.length+' ?',yes => {

                if ( !yes ) return;

                WebSoc.SEND('update',{ DB: 'clients', _id: this.client._id, update: { $set: updateClient } },() => {
                    console.log('udpatedClient');
                })

                this.progress = {
                    sent: 0,
                    fail: 0
                }

                this.emailCustomers = [];
                WebSoc.SEND('sendCampaign',{ _id: this.sendingCampaign._id, client_id: this.client_id, customers, emailHtml, emailSubject },resp => {
                    console.log('resp',resp);
                    resp.sent && ( this.progress.sent = resp.sent )
                    resp.fail && ( this.progress.fail = resp.fail )
                })
            })

        },
        'survey-list' ({ field, item, value, e })  {
            console.log('field.field',field.field);
            switch ( field.field ) {
                case 'title': return this.showCampaign(item._id);
                case 'send': return this.sendCampaign(item);
            }
        },
        emit ( data ) {
            console.log('Campaigns emit',data);
            if ( data.action == 'new' ) return this.addCampaign();
            if ( data.action == 'send' ) return this.sendCampaign({ title: 'Send Message' });
            if ( data.action == 'send-sms' ) return this.sendCampaign({ title: 'SMS Only', sendEMAIL: false, sendSMS: true  });
            if ( data.action == 'send-email' ) return this.saveCampaign({ title: 'Email Only', sendEMAIL: true, sendSMS: false }) 
            if ( data.action == 'exit' ) {
                this.component = '';
                this.item = false
            }

            if ( typeof this[data.t] == 'function' ) return this[data.t](data);
            console.log('what emmit',data);
        },
        getCurrentOffers ( client_id ) {
            console.log('getCurrentOffers',client_id);
            WebSoc.SEND('search',{ DB: 'surveys', find: { client_id, currentOffers: true, live: true }},surveys => {
                console.log('currentOffers',surveys);
                var offers = surveys[0];
                if ( !offers ) return;
                offers.pages.forEach(page => {
                    page.removed = page.removed || false;
                    page.campaign_id = offers._id
                });
                this.offers = offers;
            })
        },
        downMove ( e, campaign, page ) {
                e.preventDefault();
            var src = e.target;
            var ele = src.parentElement;
            var pos = ele.getBoundingClientRect();
            var box = ele.parentElement;
            var container = box.parentElement;
            var offers = container.classList.contains('offers-scroller');

                if ( offers ) {
                    var parentPos = container.getBoundingClientRect();
                    var boxPos = box.getBoundingClientRect();
                } else {
                    boxPos = ele.getBoundingClientRect();
                    parentPos = box.getBoundingClientRect();
                }

                ele = ele.cloneNode(true);
                ele.classList.add('ad-mover');
                ele.style.position = 'Fixed';
                ele.style.top = pos.top+'px'
                ele.style.left = pos.left+'px';
                ele.style.opacity = 0.8;
                this.moving = { campaign, offers, ele: ele, startX: e.clientX, startY: e.clientY, x: e.clientX, y: e.clientY, left: pos.left, top: pos.top, width: boxPos.width + 20, height: boxPos.height, campaign: campaign, page: page, row: parseInt(parentPos.width / (boxPos.width + 20)), currentPOS: campaign.pages.indexOf(page), parentTop: parentPos.top, parentWidth: parentPos.width, parentHeight: parentPos.height }
                document.body.appendChild(ele);

                var that = this;

                document.body.addEventListener('mousemove',(e) => page && this.$el && this.$el.parentElement && this.moveMove(e,campaign,page)); 
                //ele.addEventListener('mouseleave',(e) => this.$el && this.$el.parentElement && this.upMove(e,campaign,page)); 
                ele.addEventListener('mouseup',(e) => page && this.$el && this.$el.parentElement && this.upMove(e,campaign,page)); 
                /*
                document.body.addEventListener('mousmove',mousemove);
                document.body.addEventListener('mouseup',mouseup);

                function mousemove(e) { 
                    if ( !(page && that.$el && that.$el.parentElement)) return document.body.removeEventListener(mousemove)
                    that.moveMove(e,campaign,page) 
                }
                function mouseup(e) {  
                    if ( !(page && that.$el && that.$el.parentElement)) return document.body.removeEventListener(mouseup)
                    that.upMove(e,campaign,page) 
                }
                */
        },
        upMove ( e, campaign, page ) {
            var moving = this.moving;
            if ( moving ) {
                var ele = moving.ele;
                ele && document.body.removeChild(ele);
                this.moving = false;
                setTimeout(() => {
                    moving.ele == this.moving.ele && ( this.moving = false );
                },1000);

                var dropBox = this.$el.querySelector('.campaign-offers').getBoundingClientRect();

                var x1 = dropBox.x, x2 = dropBox.x + dropBox.width;
                var y1 = dropBox.y, y2 = dropBox.y + dropBox.height;
                var x = e.clientX, y = e.clientY;

                if ( x > x1 && x < x2 && y > y1 && y < y2 ) this.addToCampaign(page);
            }
        },
        removePageFromCampaign ( e, campaign, page ) {
            if ( page.removed && e.shiftKey ) {
                page.removed = false;
                e.preventDefault();
                e.stopPropogation();
                return  this.updateCampaign({
                            campaign,
                            unRemovePage: page
                        });;
            }

            if ( page.removed ) {
                return Alert.yesno('Remove PERMANENTLY from Campaign?',yes => {
                    if ( !yes ) return;
                    campaign.pages = campaign.pages.filter(P => P != page)
                    this.updateCampaign({
                        permRemovePage: page,
                        campaign
                    });
                })
            }

            this.removePage = page;
            this.removeFromCustomers = false;
            this.removeFromCampaign = true;
        },
        removeAdFromCampaign ( page ) {
            this.removePage = false;
            var { removeFromCampaign, removeFromCustomers, campaign } = this;
            page.removed = true;
            this.$forceUpdate();
            this.updateCampaign({
                removePage: page,
                campaign,
                removeFromCampaign,
                removeFromCustomers
            });;
           
        },
        addToCampaign ( page ) {
            
            var campaign = this.campaign;
            if ( campaign.pages.indexOf(page) > -1 ) return;

            var addPage = JSON.parse(JSON.stringify(page));

            getCampaignPageCode(campaign,code => {
                    addPage.code = code;
                    campaign.pages.push(addPage);
                    this.updateCampaign({
                        campaign,
                        addPage
                    });
                });            
        },
        moveMove ( e, campaign, page ) {
            if ( !this.moving ) return;
            e.preventDefault();
            var moving  = this.moving, that = this;
            var ele     = moving.ele;
            var x = e.clientX - moving.x;
            var y = e.clientY - moving.y;
                ele.style.left = moving.left + x + 'px';
                ele.style.top = moving.top + y + 'px';
                if ( !e.shiftKey ) return;
                //console.log({
                //    campaign: campaign == this.campaign,
                //    offers: campaign == this.offers
                //});
                if ( e.clientY - moving.parentTop < 0 ) return;
                if ( ( moving.parentTop + moving.parentHeight ) - e.clientY < 0 ) return;
                if ( e.clientX - moving.startX > 0 ) {  
                    // right
                    Math.abs(moving.startX - e.clientX) > ( moving.width / 2 ) && moveLeft(+1)
                } else { 
                    // left
                    Math.abs(moving.startX - e.clientX) > ( moving.width / 2 ) && moveLeft(-1)
                 }
                //if ( moving.startX - e.clientX > ( moving.width / 2 ) )   moveLeft(-1);
                //if ( moving.startX - e.clientX < - ( moving.width / 2 ) ) moveLeft(+1);
                if ( moving.startY - e.clientY > ( moving.height / 2 ) )   moveTop(-1);
                if ( moving.startY - e.clientY < - ( moving.height / 2 ) ) moveTop(+1);

                function moveLeft(dir) {  
                     
                    var page = moving.page;               
                    campaign.pages.splice(campaign.pages.findIndex(p => p.code == page.code),1);
                    campaign.pages.splice(moving.currentPOS += dir,0,page);
                    moving.startX = e.clientX; // + ( ( moving.width / 2 ) * dir );
                    that.updatePages({
                        campaign,
                        pages: campaign.pages
                    });
                }

                function moveTop(dir) {
                   
                    var page = moving.page;   
                    campaign.pages.splice(campaign.pages.findIndex(p => p.code == page.code),1);
                    if ( moving.offers ) {
                        campaign.pages.splice(moving.currentPOS += dir,0,page);
                    } else {
                        campaign.pages.splice(moving.currentPOS += ( ( moving.row + 1 ) * dir ),0,page);
                    }
                    moving.startY = e.clientY + ( ( moving.height / 2 ) * dir );
                    that.updatePages({
                        campaign,
                        pages: campaign.pages
                    });
                }

        }, 
        ...mapMutations([
            'setValue'
        ]), 
        ...mapActions([
            'removeCampaign',
            'updatePages',
            'updateCampaign',
        ])      
    }
}    
</script>

<style scopped lang="scss">
.offers-scroller > p.btn { width: 300px; }    
.no-sms {
    position: relative;
    &:before {
        content: '';
        background-image: url('/mobile-phone.png');
        width:20px;
        height: 20px;
        float: left;
        margin-right: 5px;
        background-size: contain;
    }
} 
.no-email {
    position: relative;
    &:before {
        content: '';
        background-image: url('/no-email.png');
        width:20px;
        height: 20px;
        float: left;
        margin: 2px 3px 0px 0px;
        background-size: contain;        
    }
}   
.progress-box {
    > p { width: 120px; padding: 10px 140px; }
    span { width: 10px; text-align: right; margin-left: 20px; text-align: right; float: right; }
}    
.v-alert.sms-message {
    textarea { min-width: calc(100% - 20px); max-width: calc(100% - 20px); margin: 5px; min-height: 200px; font-size: 20px; padding: 5px;}
    .sms-message-title { margin: 5px 0px 0px 5px; }
}    
.send-selected {
    position: absolute;
    width: 300px;
    margin-left: calc(50% - 150px);
    text-align: center;
    margin-top: 10px;
}    
.send-campaign {
    .selection-list {
        display: grid;
        grid-template-columns: 325px 1fr;
        grid-gap: 10px;
        min-height: 425px;
        max-height: 425px;
        > div {
            margin: 9px;
            border: 1px solid #c0c0c0;
            > div {
                margin: 5px;
            }
        }
        .select-from-list {
            position: relative;
            overflow-y: scroll;
            max-height: 400px;
            min-height: 400px;
            > div {
                display: grid;
                grid-template-columns: 140px 150px;
                &.selected {
                    background-color: rgba(0,255,0,0.2);
                }
            }
        }
        .selected-list {
            max-height: 400px;
            min-height: 400px;
            position: relative;
            overflow-y: scroll;
            > div {
                width: 173px;
                background-color: rgba(100,100,100,0.1);
                float: left;
                height: 22px;
                line-height: 22px;
                position: relative;
                .x {
                    transform: scale(0.5) translate(13px,-17px);
                }
            }
        }
    }
    .header-search {
        width: 400px;
        margin: 10px 0px 0px 10px;
        width: 292px;
    }
    .header-search-sending {
        margin: 0px 0px 0px 28px;
        width: 292px;
    }
}    
.add-managers {
    position: absolute;
    top: 0px;
    right: 50px;
    width: 140px;
    > p { margin: 0px; float: left; margin-top: 2px; }
    > input { float: left; margin: 6px 0px; }
}    
.send-text {
    width: 180px;
    position: absolute;
    right: 0px;
    top: 40px;
    margin: 10px;
    select {
        margin: 0px;
        width: 100%;
    }
    input { margin: 10px; float: left; }
    p { float: left; margin-top: 12px; }
}
.s-btn {
    background-color: rgb(0, 123, 200);
    text-align: center;
    color: white;
    font-size: 16px !important;
    position: relative;
    left: 7px;
    &:active {
        transform: translate(2px,2px)
    }
}    
.campaign-container {
    position: absolute;
    margin: 40px 10px;
    width: calc(100% - 480px);
    background-color: white;
    border: 1px solid #c0c0c0;
    .label {
        width: calc(100% - 40px);
        float: left;
        margin: 20px;
        > p { width: 70px; float: left; font-size: 20px; padding: 2px; }
        > input { width: 240px; float: left; font-size: 20px; }
        > p.btn { line-height: 25px; font-size: 16px; margin: 0px 10px;  width: 120px; }
    }
    .campaign-title p {
        text-align: center;
        line-height: 40px;
        border-bottom: 1px solid #c0c0c0;
    }
    .campaign-offers {
        width: 100%;
        height: 100%;
        min-height: 400px;
        float: left;
        > div {
            float: left;
        }
        .ad-img {
            margin-bottom: -130px;
        }
    }
}    
</style>